import React, { useState,useEffect } from 'react'
import { AgGridReact } from "ag-grid-react";
import { SBADrawer } from "../../../../UiComponents/SBADrawer";
import {SBAComboBox} from "../../../../UiComponents/SBADropDown";
import {getBillingGetExistingClientsAPI,insertInvoice,insertInvoiceMapping,getPortfolioListAPI,getBillingInvoice,getBillingInvoiceMapping,deleteInvoiceMapping,getBillingInvoiceNewMappingAPI} from "../../../../../config/apiConfig";
import { sbaAxios } from "../../../../utils/sbaAxios";
import { SBNotify } from "../../../../utils/sbNotify";
import { Modal } from "react-bootstrap";
import moment from "moment";
export const StatementMap = () => {
  const [showInvcDrawer,setshowInvcDrawer]=useState(false);
  const [showInvcMapDrawer,setshowInvcMapDrawer]=useState(false);
  const [billingData,setbillingData]=useState([]);
  const [selectedClientbilling,setselectedClientbilling]=useState([]);
  const [selectedInvoiceName,setselectedInvoiceName]=useState();
  const [portfolio,setPortfolio]=useState([]);
  const [selectedportfolio,setselectedportfolio]=useState([]);
  const [selectedbillingInvoiceId,setselectedbillingInvoiceId]=useState();
  const [selectedClientBillingId,setselectedClientBillingId]=useState();
  const [billingInvoice,setbillingInvoice]=useState([]);
  const [billingInvoice1,setbillingInvoice1]=useState([]);
  const [invoiceMappingdata,setInvoiceMappingData]=useState([]);
  const [showModal,setShowModal]=useState(false);
  const[selectedInvoiceMappingId,setselectedInvoiceMappingId]=useState();
useEffect(() => {
  getClientBilling();
 
  getBillingInvoiceList();
},[])
  const getClientBilling = async () => {
    try {

        const response = await sbaAxios({
            url: `${getBillingGetExistingClientsAPI}`,
            method: 'get',
        });
        setbillingData(response)
       
    } catch (error) {
        console.error("Error fetching get billing data from API:", error);
    }
};
const getPortfolio = async (billingInvoiceId) => {
  try {

      const response = await sbaAxios({
          url: `${getBillingInvoiceNewMappingAPI}/${billingInvoiceId}`,
          method: 'get',
      });
      setPortfolio(response);
     
  } catch (error) {
      console.error("Error fetching get portfolio from API:", error);
  }
};
const getBillingInvoiceList= async (billinginvoiceid,clntbillingId)=>
{
  try {

    const response = await sbaAxios({
        url: `${getBillingInvoice}`,
        method: 'get',
    });
    if(response.length>0)
    {
    setbillingInvoice(response);
    setbillingInvoice1(response);
    setselectedbillingInvoiceId(response[0].BillingInvoiceId);
    setselectedClientBillingId(response[0].ClientBillingId);
    if(billinginvoiceid !==undefined && clntbillingId !==undefined)
    {
    getBillingInvoiceMappingList(billinginvoiceid,clntbillingId);
    getPortfolio(selectedbillingInvoiceId);
    }
    else
    {
    getBillingInvoiceMappingList(response[0].BillingInvoiceId,response[0].ClientBillingId);
    }

    }
   
} catch (error) {
    console.error("Error fetching get billing invoice from API:", error);
}
}
const dateValueFormatter = (params) => {
  return params !== null
      ? moment(params).format("MM/DD/YYYY")
      : "";
};
const getBillingInvoiceMappingList= async (billingInvcId,clientBillingId)=>
{
  try {

    const response = await sbaAxios({
        url: `${getBillingInvoiceMapping}${billingInvcId},${clientBillingId}`,
        method: 'get',
    });
    if(response.length>0)
    {
    
    setInvoiceMappingData(
      response.map((item,index)=>({...item,ModifiedDate:dateValueFormatter(item.ModifiedDate)}))
    );
    }
    else
    {
      setInvoiceMappingData([]);
    }
} catch (error) {
    console.error("Error fetching get billing invoice from API:", error);
}
}
const ActionsRenderer = (event) => {
  

  return (
      <div className="actions-cell"> 
          <i  onClick={(e) => {deleteclick(event)}}
              className="fa fa-trash"
              style={{ color:"#DF001B", margin: "0 8px", cursor: "pointer" }}
          ></i>
      </div>
  );
};

  const InvcolDef = [
    { headerName: "Invoice Name", field: "BillingInvoiceName" }
  ]
  const BillingcolDef = [
    { headerName: "Client Billing Name", field: "ClientBillingName" },
    { headerName: "Portfolio Name", field: "PortfolioName" },
    { headerName: "Modified By", field: "ModifiedByUserName" },
    { headerName: "Modified Date", field: "ModifiedDate" },
    {headerName: "Delete",cellRenderer:ActionsRenderer}
  ]
  const defaultColDef = {
    sortable: true,
    filter: false,
    suppressMovable: true,
    flex: 1,
    resizable:true
  };
 const openInvcDrawer=()=>
 {
  setshowInvcDrawer(true);
 }
 const openInvcMappingDrawer=()=>
 
 {
  setselectedportfolio([]);
  setshowInvcMapDrawer(true);
  getPortfolio(selectedbillingInvoiceId);
 }

 const closeInvcDrawer=()=>
 {
  setselectedClientbilling([]);
  setshowInvcDrawer(false);
 }
 const closeInvcMappingDrawer=()=>
 {
  setshowInvcMapDrawer(false);
 }

 const clientBillingDDChng = (e) => 
 {    
  if (e.value) {
      setselectedClientbilling({ClientBillingId:e.value.ClientBillingId,ClientBillingName:e.value.ClientBillingName});
  }
};
const InvcNameChange=(e)=>
{
  setselectedInvoiceName(e.target.value);
}
const PortfolioDDChng = (e) => {
      
  if (e.value) {
    setselectedportfolio(e.value);
    
  }

};
const InsertInvoice = async () => {

  let ifsave = true;
  
  if (selectedClientbilling.length===0) {
    ifsave = false;
    SBNotify({ Msg: "Please Select Client Billing", type: "error" });
  }
  else if (!selectedInvoiceName) {
    ifsave = false;
    SBNotify({ Msg: "Please Enter Invoice Name", type: "error" });
  }
 
  if (ifsave) {
    sbaAxios({
      url: `${insertInvoice}${selectedClientbilling.ClientBillingId},${selectedInvoiceName},${0}`,
      method: "Get"
    }).then((response) => {
      setshowInvcDrawer(false);
        SBNotify({ Msg: "Invoice Saved Successfully", type: "success" });
        getBillingInvoiceList(response,selectedClientbilling.ClientBillingId);  
       getPortfolio(selectedbillingInvoiceId);
       
    }).catch((error) => {
      SBNotify({ Msg: "some error  occured", type: "error" });
    });
  }

};
const InsertInvoiceMapping = () => {

  let ifsave = true;
  
  if (!selectedbillingInvoiceId) {
    ifsave = false;
    SBNotify({ Msg: "Please Select Invoice", type: "error" });
  }
  else if (selectedportfolio.length ==0) {
    ifsave = false;
    SBNotify({ Msg: "Please Select Portfolio", type: "error" });
  }
 
  if (ifsave) {
    sbaAxios({
      url: `${insertInvoiceMapping}${selectedbillingInvoiceId},${selectedportfolio.PortfolioId},${0}`,
      method: "Get"
    }).then((response) => {
      setshowInvcMapDrawer(false);
        SBNotify({ Msg: "Billing Invoice Mapped  Successfully", type: "success" }); 
        getBillingInvoiceMappingList(selectedbillingInvoiceId,selectedClientBillingId)  
    }).catch((error) => {
      SBNotify({ Msg: "some error  occured", type: "error" });
    });
  }

};
const invcrowClick=(row)=>
{
  const invid=row.data.BillingInvoiceId;
  const billingid=row.data.ClientBillingId;
  setselectedClientBillingId(billingid);
  setselectedbillingInvoiceId(invid);
  getBillingInvoiceMappingList(invid,billingid);
  getPortfolio(invid);
}
const deleteclick = (e) => {
  if (e.data) {
    setselectedInvoiceMappingId(e.data.BillingInvoiceMappingId)
      setShowModal(true);
  }
};
const deletemappingdata=()=>
{
  sbaAxios({ url: `${deleteInvoiceMapping}${selectedInvoiceMappingId}` }).then(res => {
    SBNotify({ Msg: "Mapping data  Deleted Successfully", type: "success" });
    setShowModal(false);
    getBillingInvoiceMappingList(selectedbillingInvoiceId,selectedClientBillingId);
}).catch(error => {
    SBNotify({ Msg: error, type: "error" });
    setShowModal(false)
})
}

  return (
    <>
    <div className="row">
 <div className='col-12 col-md-4'>
  <div className='d-flex justify-content-between'>
  <div>
          <label className="mb-1 label">Invoice Name</label>
          <div>
            <input type="text"
              className="w-100 form-control"
              onChange={(e)=>{
                const filters=e.target.value;
                const filteredData=billingInvoice1.filter(item=>item.BillingInvoiceName.includes(filters));
                setbillingInvoice(filteredData);
              }}
            />
          </div>
        </div>
        <button className="p-sm-btn mt-auto" onClick={openInvcDrawer}>Add</button>


  </div>
    
      </div>
     
      <div className='col-12 col-md-8 row-items justify-content-end'>
        <button className="p-sm-btn d-flex justify-content-end gap-12" onClick={openInvcMappingDrawer}>Add</button>
      </div>
          </div>
          <div className="row">
          <div className='col-12 col-md-4'>
          <div className="ag-theme-alpine m-1" style={{ height: '400px' }}>
          <AgGridReact rowData={billingInvoice} onRowClicked={invcrowClick}  columnDefs={InvcolDef} defaultColDef={defaultColDef} />
        </div>
        </div>
        <div className='col-12 col-md-8'>
          <div className="ag-theme-alpine m-1" style={{ height: '400px' }}>
          <AgGridReact rowData={invoiceMappingdata}  columnDefs={BillingcolDef} defaultColDef={defaultColDef} />
        </div>
        </div>

        </div>
        <SBADrawer
        open={showInvcDrawer}
        setOpen={setshowInvcDrawer}
        close={false}
        title={"Insert Billing Invoice"}
      >
        <div>
          <div>
            <div className="mb-4">
              <label className="mb-1 ms-2 fw-semibold fs-12">
               Client Billing Name
                <span className="mandatory">*</span>
              </label>
                                                
              <div>
                <SBAComboBox
                  className="w-50"
                  data={billingData}
                  textField={"ClientBillingName"}
                  valueField={"ClientBillingId"}
                  onChange={clientBillingDDChng}
                  popupSettings={{ className: "modalDD" }}
                  value={selectedClientbilling}
                 
                />

              </div>
            </div>
            <div className="mb-4">
              <label className="mb-1 ms-2 fw-semibold fs-12">
                Invoice Name
                <span className="mandatory">*</span>
              </label>
            
              <div>
              <input type="text"
              className="w-50 form-control"  
              onChange={InvcNameChange}           
            />
              </div>
            </div>
     </div>
     </div>
     <div className="mt-4">
              <button className="s-sm-btn mx-1" onClick={closeInvcDrawer}>
                Cancel
              </button>
              <button className="p-sm-btn mx-1" onClick={InsertInvoice}>
                Save
              </button>
            </div>
     </SBADrawer>


     <SBADrawer
        open={showInvcMapDrawer}
        setOpen={setshowInvcMapDrawer}
        close={false}
        title={"Insert Invoice Mapping"}
      >
        <div>
          <div>
            <div className="mb-4">
              <label className="mb-1 ms-2 fw-semibold fs-12">
                Portfolio Name
              <span className="mandatory">*</span>
              </label>
              <div>
                <SBAComboBox
                  className="w-50"
                  data={portfolio}
                  textField={"PortfolioName"}
                  valueField={"PortfolioId"}
                  onChange={PortfolioDDChng}
                  popupSettings={{ className: "modalDD" }}
                  value={selectedportfolio}
                />
              </div>
            </div>
          
     </div>
     </div>
     <div className="mt-4">
              <button className="s-sm-btn mx-1" onClick={closeInvcMappingDrawer}>
                Cancel
              </button>
              <button className="p-sm-btn mx-1" onClick={InsertInvoiceMapping}>
                Save
              </button>
            </div>
     </SBADrawer>
     <Modal show={showModal}  >
                <Modal.Header closeButton onClick={() => { setShowModal(false) }}>
                    <Modal.Title>Invoice Mapping Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to delete this mapping</p>
                </Modal.Body>
                <Modal.Footer>
                    <button className="s-sm-btn mx-1" onClick={() => { setShowModal(false) }}>Cancel</button>
                    <button className='p-sm-btn mx-1' onClick={() => { deletemappingdata() }} >
                        Yes
                    </button>
                </Modal.Footer>
            </Modal>
        </>
       
  )
}
